import Brain from '../../classes/brain';
import Utils from '../../classes/utils';
import LFO from '../../classes/lfo';

export default class BrainScaleTest extends Brain {

	constructor(args) {
		super(args);

		this.lfo = new LFO(Utils.randomFloat(0.1,0.3));
		this.rotSpeed = Utils.randomFloat(-0.002,0.002);
	}

	init(entity) {
		super.init(entity);

		let g = entity.sprite.g;

		g.onpointerdown = (e) => {
			console.log('hello');
		};
	}

	update(delta) {
		super.update(delta);

		this.lfo.update(delta);

		this.entity.sprite.position.scale = 1 + this.lfo.value*1;
		this.entity.sprite.position.rotation += this.rotSpeed*delta;
	}

}